export default __webpack_public_path__ + "static/media/decoder_ring_screen_large.426d1640.png";